import { GiftGraphic } from "../Windows/GiftUI/GiftGraphic";

// config 
// tutorial: bool

G.TreasureHunt.TreasureHuntProgressionPanel = function(config) {
  // imports
  var treasureHuntMgr = G.TreasureHunt.treasureHuntMgr;
  var TreasureHuntTutorial = G.TreasureHunt.TreasureHuntTutorial;
  var PFEventPanel = G.PFEventPanel;

  config = Object.assign({
    progressBar: {
      label: false,
      overlaySprite: "goalPanel_bar_full",
    },
    sounds: {
      onIncrease: null,
      onComplete: null,
    },
  }, config);

  // console.log(config);

  // TODO: change PF/TH to longer names
  PFEventPanel.call(this, config);

  this.bg.changeTexture("under_window_panel");
  this.bg.inputEnabled = false;
  this.bg.parent.y += 40;
  this.bg.parent.x -= 10;
  this.progressBar.position.setTo(-195, 4);
  this.progressBar.width = 400;
  this.progressBar.height = 30;

  this.descTxt = this.add(new G.Text(0, -17,
    " ", {
    style: "font-white",
    fontSize: 35,
  }, 0.5, 300));

  if (config.valueTarget === config.target) {
    this.shine = G.makeImage(212, 15, "popup_lighht", 0.5, this);
    this.shine.name = "shine";
    this.shine.alpha = 0.3;
    this.shine.blendMode = 1;
    this.shine.scale.setTo(0.5);
    G.Animations.getShineAnimation().animate(this.game, this);
  }

  this.gemIcon = G.makeImage(-218, 8, "gem5_small", 0.5, this);
  this.gemIcon.name = "gem";
  this.chestIcon = new GiftGraphic(210, 12, { giftType: 1, useFullGift: true }, this); // G.makeImage(212, 15, "prezent", 0.5, this);
  this.chestIcon.scale.setTo(0.4);

  if (config.tutorial) {
    this.tutorialBtn = new G.Button(236, -42, "info_button", function() {
      new TreasureHuntTutorial()
    }, this);
    this.add(this.tutorialBtn);
  }

  this.onValueChanged.add(onValueChanged);

  var panel = this;
  var boingAnimationRunning = false;
  var previousValue = this.valueObj.value;
  var target = this.valueObj.target;

  refreshDesc();

  function onValueChanged(value) {
    if (Math.floor(previousValue) !== Math.floor(value)) {
      refreshDesc();
      boingGem();

      if (value === target) {
        if (config.sounds.onComplete && !config.sounds.onComplete.isPlaying) {
          panel.config.sounds.onComplete.play();
        }
      } else {
        if (config.sounds.onIncrease && !config.sounds.onIncrease.isPlaying) {
          config.sounds.onIncrease.play();
        }
      }
    }
    previousValue = value;
  };

  function refreshDesc() {
    var str = OMT.language.getText("Collect [#] Gems").replace(
      "[#]", Math.floor(panel.valueObj.value)+"/"+panel.valueObj.target);

    // it is integer change
    if (panel.descTxt.text !== str) {
      panel.descTxt.setText(str);
    }
  };

  function boingGem() {
    if (boingAnimationRunning) return;
    boingAnimationRunning = true;
    var animation = G.Animations.getTreasureHuntGemBounceAnimation();
    animation.animate(game, panel.gemIcon);
    animation.onComplete.add(function() {
      boingAnimationRunning = false;
    });
  };
};

G.TreasureHunt.TreasureHuntProgressionPanel.prototype = Object.create(G.PFEventPanel.prototype);